import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { CapabilitiesResponse } from '../entities/academy-capabilities.model';

/**
 * HTTP client for the session's Academy capabilities. The server applies the same
 * rule as its producer gate, so the front gates producer menus and routes on this
 * answer instead of a local tenant list; the server stays the real barrier.
 */
@Injectable({ providedIn: 'root' })
export class CapabilitiesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.academy_service;

  /**
   * `GET /Capabilities/me` — capabilities of the signed-in person in the current
   * tenant. Authenticated; the action itself never answers 403.
   */
  public me(): Observable<CapabilitiesResponse> {
    return this.http.get<CapabilitiesResponse>(
      `${this.baseUrl}/Capabilities/me`,
      { withCredentials: true }
    );
  }
}
